/**
 * index.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

export { AggregationSubjectContextRequest }
    from "./aggregation-subject-context-request";
export { AggregatorFailureResponse } from "./aggregator-failure-response";
export { AggregatorReportResponse } from "./aggregator-report-response";
export { AggregatorStatusResponse } from "./aggregator-status-response";
export { AvailableAggregatorsResponse } from "./available-aggregators-response";
export {
    AggregatorStatusRequest,
    CancelAggregationRequest,
    DeleteAggregatorRequest,
    PauseAggregatorRequest,
    ResumeAggregatorRequest
} from "./basic-aggregation-requests";
export { CreateAggregatorRequest } from "./create-aggregator-request";
export { CreateAggregatorResponse } from "./create-aggregator-response";
export { StartAggregatorRequest } from "./start-aggregator-request";



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/aggregation/index.ts